import React from 'react';
import dentalTechImg from '../../assets/dentalTechnologyImg.jpg';
import { Link } from 'react-router';

const TechnologyDetail = () => {
  return (
    <div className="mx-auto px-4 sm:px-6 lg:px-8 xl:px-20 py-16 bg-gray-50">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
        
        {/* Image Section */}
        <div className="relative">
          <img
            src={dentalTechImg}
            alt="Dental professional performing digital scan"
            className="rounded-2xl shadow-xl w-full h-auto object-cover"
          />
          {/* Decorative element matching the logo colors */}
          <div className="absolute -bottom-4 -right-4 w-24 h-24 rounded-full bg-lime-500 opacity-20 z-0"></div>
          <div className="absolute -top-4 -left-4 w-16 h-16 rounded-full bg-teal-600 opacity-20 z-0"></div>
        </div>

        {/* Content Section */}
        <div className="space-y-6">
          {/* Badge/Label */}
          <span className="inline-block bg-teal-100 text-teal-600 font-semibold text-sm px-3 py-1 rounded-full">
            Technology-Driven Dentistry
          </span>

          {/* Heading */}
          <h1 className="text-4xl sm:text-5xl font-extrabold text-gray-900 leading-tight">
            Discover the Future of <span className="text-teal-600">Dental Care</span>
          </h1>

          {/* Paragraphs */}
          <p className="text-lg text-gray-600">
            At Pristine Smile, we combine experience with cutting-edge dental technology to give you faster, more accurate, and more comfortable treatment. From digital impressions to 3D imaging, we invest in tools that put your smile first.
          </p>

          <p className="text-lg text-gray-600">
            Whether you're here for a routine checkup or a full smile makeover, our technology allows us to diagnose better, treat smarter, and deliver beautiful results—efficiently and comfortably.
          </p>

          {/* Features List */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-2">
            <div className="flex items-start">
              <div className="flex-shrink-0 h-6 w-6 rounded-full bg-lime-500 flex items-center justify-center">
                <svg className="h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <p className="ml-3 text-base text-gray-600">Digital Impressions</p>
            </div>
            <div className="flex items-start">
              <div className="flex-shrink-0 h-6 w-6 rounded-full bg-teal-600 flex items-center justify-center">
                <svg className="h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <p className="ml-3 text-base text-gray-600">3D Imaging</p>
            </div>
            <div className="flex items-start">
              <div className="flex-shrink-0 h-6 w-6 rounded-full bg-lime-500 flex items-center justify-center">
                <svg className="h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <p className="ml-3 text-base text-gray-600">Laser Dentistry</p>
            </div>
            <div className="flex items-start">
              <div className="flex-shrink-0 h-6 w-6 rounded-full bg-teal-600 flex items-center justify-center">
                <svg className="h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <p className="ml-3 text-base text-gray-600">Same-Day Restorations</p>
            </div>
            <div className="flex items-start">
              <div className="flex-shrink-0 h-6 w-6 rounded-full bg-lime-500 flex items-center justify-center">
                <svg className="h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <p className="ml-3 text-base text-gray-600">Invisalign Provider</p>
            </div>
            <div className="flex items-start">
              <div className="flex-shrink-0 h-6 w-6 rounded-full bg-teal-600 flex items-center justify-center">
                <svg className="h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <p className="ml-3 text-base text-gray-600">Nitrous Oxide Sedations (Laughing Gas)</p>
            </div>
          </div>

          {/* Call to Action */}
          <div className="pt-4">
            <Link
              to='/schedule-appointment'
              className="inline-block bg-teal-600 hover:bg-teal-700 text-white text-base font-medium px-6 py-3 rounded-full shadow-md transition duration-300"
            >
              Schedule a Visit
            </Link>
            <Link
              to="/general"
              className="inline-block ml-4 bg-white text-teal-600 border border-teal-600 hover:bg-teal-50 text-base font-medium px-6 py-3 rounded-full shadow-sm transition duration-300"
            >
              Learn More
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TechnologyDetail;